import { CurrencyPipe } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { Filter, FilterModel } from 'src/app/core/models/filter';
import { PaginationList } from 'src/app/core/models/pagination-list';
import { Dialog } from 'src/app/core/resources/dialog';
import { Utils } from 'src/app/core/resources/utils';
import { AuthService } from 'src/app/core/services/authentication.service';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { CargoItemService } from '../cargo-item/cargo-item.service';
import { FreightListService } from '../cargo-list/cargo-list.service';
import { ListFilterComponent } from 'src/app/shared/list-filter/list-filter.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { ConventionsComponent } from 'src/app/shared/conventions/conventions.component';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Permission } from 'src/app/core/resources/permission';
import { CargoStateEnum } from 'src/app/core/enums/cargoState.enum';
import { ApprovalStateEnum, TravelExpense } from 'src/app/core/interfaces/travel-expense';
import { SelectableItem } from 'src/app/core/interfaces/selectableItem';

@Component({
  selector: 'app-cargo-list-payments',
  templateUrl: './cargo-list-payments.component.html',
  styleUrls: ['./cargo-list-payments.component.scss'],
  providers: [CurrencyPipe]
})
export class CargoListPaymentsComponent implements OnInit {

  @ViewChild(ListFilterComponent) listFilterComponent: ListFilterComponent;
  @Input() typeList: string;
  itemsSelecteds: Array<Cargo> = [];
  filters: string = '';
  activeSelectItemToPay = false;
  enableSelectItemByList = false;
  optionsFilter: FilterModel[] = [];
  paginationList: PaginationList = new PaginationList();
  permission = Permission;

  constructor(
    private spinner: NgxSpinnerService,
    public service: FreightListService,
    public utils: Utils,
    public authService: AuthService,
    private managerDialog: Dialog,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private cargoItemService: CargoItemService,
    private permissionRole: PermissionRole

  ) {
    localStorage.removeItem('hasOpenEval');
  }

  ngOnInit() {
    this.paginationList.setPageSize(10);
    this.optionsFilter = this.service.getOptionsFilter(this.typeList);
    this.enableSelectItemByList = this.utils.enableSelectItemByList(this.typeList);
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  onFilter($event) {
    this.resetPagging();
    this.filters = $event;
    this.getListCargo(this.filters);
  }

  getListCargo($event, scrolled: boolean = false) {
    let service = null;
    const isTravelExpensePayment = this.service.isTravelExpensePayment(this.typeList);
    const isPendingPaymentCargo = this.service.isPaymentCargo(this.typeList) && $event.search('paid=true') === -1;
    if (!scrolled) this.itemsSelecteds = [];
    this.spinner.show();
    // Viáticos
    if (isTravelExpensePayment) {
      service = this.service.getListCargoTravelExpenses(
        $event,
        this.paginationList.getPageKey(),
        this.paginationList.getPageSize()
      );

      this.activeSelectItemToPay = true;
    } else if (isPendingPaymentCargo) {
      // Payment
      service = this.service.getListCargoToPay(
        $event,
        this.paginationList.getPageKey(),
        this.paginationList.getPageSize()
      );
      this.activeSelectItemToPay = true;
    } else {
      // General
      this.activeSelectItemToPay = false;
      $event = $event.replace('&paymentType=advanceState', '');
      service = this.service.getListCargo(
        $event,
        this.paginationList.getPageKey(),
        this.paginationList.getPageSize()
      );
    }

    service.subscribe(
      (response: any) => {
        let data: any[] = isTravelExpensePayment
          ? ((response && response.results) || [])
          : (isPendingPaymentCargo ? (response || []) : ((response && response.results) || []));
        if (isTravelExpensePayment || !isPendingPaymentCargo) {
          const total = response && response.pagination && this.utils.isDefined(response.pagination.total)
            ? response.pagination.total
            : data.length;
          this.paginationList.setTotal(total);
        }

        if (!this.utils.isDefined(data) || data.length === 0) {
          this.paginationList.setEnablePagingScroll(false);
          data = [];
        }

        if (this.paginationList.getList().length) {
          this.paginationList.setList(
            this.paginationList.getList().concat(data)
          );
        } else {
          this.paginationList.setList(data);
        }
        if ((!isPendingPaymentCargo && this.paginationList.hasLoadedTotal()) || data.length < this.paginationList.getPageSize())
          this.paginationList.setEnablePagingScroll(false);
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        if (!(this.paginationList.getList().length > 0)) {
          this.resetPagging();
          this.paginationList.setList([]);
        }
      }
    );
  }

  onSelectItem($event) {
    this.itemsSelecteds = $event;
  }

  resetPagging() {
    this.paginationList.setPageKey(1);
    this.paginationList.setList([]);
    this.paginationList.setTotal(0);
    this.paginationList.setEnablePagingScroll(true);
    this.activeSelectItemToPay = true;
  }

  refreshActualList() {
    !this.paginationList
      ? this.paginationList.setList([])
      : this.resetPagging();
    this.getListCargo(this.filters);
  }

  resetActualList() {
    !this.paginationList
      ? this.paginationList.setList([])
      : this.resetPagging();
  }

  refreshList($event?) {
    this.resetActualList();
    if ($event) this.filters = $event;
    this.getListCargo(this.filters);
  }

  refreshCargo($event: { cargo: Cargo, action: 'update' | 'delete' }, index: number) {
    if ($event.action === 'update') {
      const currentList = [...this.paginationList.getList()];
      currentList[index] = $event.cargo;
      this.paginationList.setList(currentList);
    } else this.refreshList();
  }

  travelExpensePayed() {
    return this.filters.search('paid=true') >= 0;
  }

  onScrollDown() {
    if (this.paginationList.getEnablePagingScroll()) {
      this.paginationList.setPageKey(
        this.paginationList.getPageKey() + 1
      );
      this.getListCargo(this.filters, true);
    }
  }


  get showSelectAll(): boolean {
    if (!this.enableSelectItemByList) return false;
    if (this.isCargoAdditionalCostsPaid() || this.isCargoAdvancePaid()) return false;
    if (this.typeList === 'paymentExtraAdvanceCargo') return this.service.canPayExtraAdvance(this.typeList).isSelectable;
    if (this.typeList === 'paymentAdvanceCargo') return this.service.canPayAdvance(this.typeList).isSelectable;
    if (this.typeList === 'paymentBalanceCargo') return this.service.canPayBalance(this.typeList).isSelectable;
    if (this.typeList === 'paymentAdditionalCostsCargo') return this.service.canPayAdditionalCosts(this.typeList).isSelectable;
    if (this.typeList === 'paymentTravelExpenses') return this.service.canPayTravelExpenses(this.typeList).isSelectable;
    if (this.typeList === 'charges') return true;
    return this.activeSelectItemToPay;
  }

  isCargoAdditionalCostsPaid() {
    return this.typeList === 'paymentAdditionalCostsCargo' &&
      this.filters.search('additionalCostPaid=true') >= 0;
  }

  isCargoAdvancePaid() {
    return this.typeList === 'paymentAdvanceCargo' &&
      this.filters.search('advanceState=true') >= 0 &&
      this.filters.search('paymentType=advance') >= 0;
  }

  isSelectableFunction = (item: Cargo) => {
    const isAvailable = this.service.loadAvailableToPay(item, this.typeList, this.filters);
    return isAvailable.isSelectable && isAvailable.isEnabled;
  }

  openConventions() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      transported: true
    };
    dialogConfig.autoFocus = false;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    this.dialog.open(ConventionsComponent, dialogConfig);
  }
  get hasOperationsInline(): boolean {
    let advanceBalancePermission = [
      "paymentAdvanceCargo",
      "paymentBalanceCargo",
      "paymentAdditionalCostsCargo"
    ].includes(this.typeList)
      && this.permissionRole.hasPermission(
        this.permission.payments.module,
        this.permission.payments.paymentAdvance
      );
    let extraAdvancePermission =
      this.typeList === "paymentExtraAdvanceCargo"
      && this.permissionRole.hasPermission(
        this.permission.payments.module,
        this.permission.payments.paymentExtraAdvance
      )
    let travelExpensesPermission = true;
    this.typeList === 'paymentTravelExpenses'
      && this.permissionRole.hasPermission(
        this.permission.payments.module,
        this.permission.payments.paymentExtraAdvance
      );

    return advanceBalancePermission || extraAdvancePermission || travelExpensesPermission;
  }

  ngOnDestroy() {
    this.cdRef.detach();
  }
}
